import { useMemo } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";

export const useToken = () => {
  const location = useLocation();
  return useMemo(() => {
    const t = queryString.parse(location.search)?.t as string;
    return t === "undefined" ? "" : t;
  }, [location]);
};
